var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          {
            staticClass: "content-wrapper",
            staticStyle: { "padding-left": "165px" }
          },
          [
            _c(
              "div",
              { staticClass: "container-wrapper center" },
              [
                _c("div", [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v(_vm._s(_vm.userFullName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "heading-seperator" }),
                _vm._v(" "),
                _c("div", [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v(_vm._s(_vm.formName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "heading-seperator",
                  staticStyle: { "margin-top": "0px" }
                }),
                _vm._v(" "),
                _c("vue-form-generator", {
                  ref: "vfg",
                  attrs: {
                    schema: _vm.formData,
                    model: _vm.model,
                    options: _vm.formOptions
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "submit-wrapper margin-bottom-15" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-md",
                      attrs: { type: "submit" },
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v("Submit")]
                  )
                ])
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e803caf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e803caf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/form_render.vue
// module id = null
// module chunks = 